const PendingIcon = () => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="0.75" y="0.75" width="22.5" height="22.5" rx="11.25" fill="#F7F7F7" />
      <g clipPath="url(#clip0_450_87289)">
        <path d="M6.99988 12.3333L10.3332 15.6667L16.9999 9" stroke="#D9D9D9" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      </g>
      <rect x="0.75" y="0.75" width="22.5" height="22.5" rx="11.25" stroke="#D9D9D9" strokeWidth="1.5" />
      <defs>
        <clipPath id="clip0_450_87289">
          <rect width="16" height="16" fill="white" transform="translate(4 4)" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default PendingIcon;
